const SurveyRoutes = [
    {
        path: '/competency-assessment/survey-report',
        name: 'SurveyReport',
        component: () => import('@/views/Staffing/Survey/Tabs/SurveyReport.vue'),
    },
    {
        path: '/competency-assessment/survey-setup',
        name: 'SurveySetup',
        component: () => import('@/views/Staffing/Survey/Tabs/SurveySetup.vue'),
    }
]

export default SurveyRoutes
